import { render, staticRenderFns } from "./FieldSidebar.vue?vue&type=template&id=582b5e2a"
import script from "./FieldSidebar.vue?vue&type=script&lang=js"
export * from "./FieldSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports